import {
  IQuestionnaireResponse,
  IQuestionnaireSaveResponseBody,
  IQuestionnaireSubmitBody,
} from "../features/questionnaires/Interfaces/IQuestionnaireInterface";
import { apiClient } from "./apiClient";
import { CONFIG } from "../config";

export async function fetchPublicQuestionnaire(
  key: string
): Promise<IQuestionnaireResponse> {
  if (!key) throw new Error("Key is required to fetch the questionnaire.");
  const url = `${
    CONFIG.API_SERVER
  }/api/questionnaire?key=${encodeURIComponent(key)}`;
  const res = await fetch(url, { method: "GET" });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Request failed (${res.status}): ${text}`);
  }
  return res.json() as Promise<IQuestionnaireResponse>;
}

export async function getQuestionnaire(
  evaluatorId: string
): Promise<IQuestionnaireResponse> {
  const { data } = await apiClient.get<IQuestionnaireResponse>(
    `/questionnaire/${evaluatorId}`
  );
  return data;
}

export async function saveQuestionnaireResponse(
  responseBody: IQuestionnaireSaveResponseBody
): Promise<void> {
  const { data } = await apiClient.post<void>(
    `/questionnaire/save-response`,
    responseBody
  );
  return data;
}

export async function submitQuestionnaire(
  submitBody: IQuestionnaireSubmitBody
): Promise<void> {
  const { data } = await apiClient.post<void>(
    `/questionnaire/submit`,
    submitBody
  );
  return data;
}
